//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import PageMixin from '~/mixins/page'
import PlansMixin from '~/mixins/plans'

export default {
  mixins: [
    PageMixin,
    PlansMixin
  ],
  data () {
    return {
      payNowButtonsId: ['#payment-request-button-header', '#payment-request-button-billing', '#payment-request-button-floating', 'planSelected'],
      plan: 'base-improvement-plan',
      showFloatingButton: false
    }
  },
  head () {
    return {
      ...this.createSeoTags({
        title: this.$t('nutritionalPlan.seo.title'),
        description: this.$t('nutritionalPlan.seo.description'),
        url: 'https://get-base.com/nutritional-plan'
      })
    }
  },
  computed: {
    ...mapGetters({
      getPlanPriceRaw: 'product/getNutritionalPlanPriceRaw'
    })
  },
  mounted () {
    window.addEventListener('scroll', () => {
      if (this.$refs.header && this.$refs.header.$el) {
        this.showFloatingButton = !this.isElementInViewport(this.$refs?.header?.$el)
      }
    }, { passive: true })
  },
  created () {
  },
  methods: {
    openRemoveQuizPlanModal () {
    },
    navigateToStripePayment () {
      window.location.href = 'https://buy.stripe.com/fZebKA041fQL0Ba7sT'
    }
  }
}
